<template>
  <section>
    <UAnnouncement></UAnnouncement>
    <HeaderDefault></HeaderDefault>
    <UHero></UHero>
    <UTicker />

    <UAlert></UAlert>
    <UBrowsebytype></UBrowsebytype>
    
    <!-- Buzz Posts Section -->
    <BuzzCardHome></BuzzCardHome>
    <UMembers></UMembers>

    <UBanner></UBanner>
    <FooterDefault></FooterDefault>
  </section>
</template>

<style>
.gd {
  @apply bg-gradient-to-r from-rose-600 to-orange-600 transition delay-150 duration-300;
}

.gd-notification {
  @apply bg-gradient-to-r from-orange-500 to-rose-600 transition delay-0 duration-500;
}

.gd:hover {
  @apply bg-gradient-to-l from-rose-600 to-orange-600;
}

.btn {
  @apply bg-blue-700 text-white p-5;
}
</style>
<script setup>
useSeoMeta({
  title: "Academic Alerts - Verified Updates on your Inbox",
  ogTitle: "AcademicAlerts.org - One Stop updates for academicians",
  description: "AcademicAlerts.org - One Stop updates for academicians.",
  ogDescription:
    "At Academic Alerts, we believe in creating a dynamic space for scholars, researchers, and enthusiasts to connect and share their passion for knowledge.",
  ogImage: "https://academicalerts.org/images/placeholder.jpg",
  twitterCard: "summary_large_image",
});
</script>
